import { CampaignPackageType } from "core/orderAd/orderAd.entity";

export enum AccountType {
  Personal = 1,
  Organization,
}

export enum AccountState {
  AwaitingDocumentSubmission = 1,
  AwaitingVerification = 2,
  Active = 3,
  DocsRejected = 4,
  Suspended = 5,
  Banned = 6,
}

export enum FeatureScope {
  Unknown,
  SubmitCampaignAd,
  SubmitSponsoredMessage,
  Festival
}

export type ApiPanelRecord = {
  id: string;
  owner_id: number;
  name: string;
  type: AccountType;
  created_at: string;
  state: AccountState;
  owner_name: string;
  full_name: string;
  shenase_melli: string;
  economic_number: string;
  phone: string;
  address: string;
  zip_code: string;
  establishment_file_id: string;
  changes_file_id: string;
  permission_file_id: string;
  national_code: string;
  reason: string;
  land_line_phone: string;
  feature_scopes: FeatureScope[] | null;
  credit: number;
  credit_expire_time: string;
  campaign_view_coef: number;
  campaign_click_coef: number;
  campaign_daily_capacity: number;
  allowed_concurrent_campaign: number;
  credit_start_date: string;
  campaign_package_type: CampaignPackageType;
  shahkar_validated: boolean;
  shahkar_exp_date: string;
};

export const defaultPanel: ApiPanelRecord = {
  id: "0",
  owner_id: 0,
  name: "",
  type: AccountType.Personal,
  created_at: "0",
  state: AccountState.AwaitingVerification,
  owner_name: "",
  full_name: "",
  shenase_melli: "",
  economic_number: "",
  phone: "",
  address: "",
  zip_code: "",
  establishment_file_id: "",
  changes_file_id: "",
  permission_file_id: "",
  national_code: "",
  reason: "",
  land_line_phone: "",
  feature_scopes: [],
  credit: 0,
  credit_expire_time: "",
  campaign_view_coef: 1000,
  campaign_click_coef: 1000,
  campaign_daily_capacity: 2,
  allowed_concurrent_campaign: 1500000,
  credit_start_date: "0001-01-01T00:00:00Z",
  campaign_package_type: 0,
  shahkar_validated: false,
  shahkar_exp_date: "",
};
